<!--  -->
<template>
  <div>
    <!-- 文鼎充值活动 -->
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="130px" class="demo-ruleForm">
      <el-form-item label="活动名称" prop="activityName">
        <el-input v-model="ruleForm.activityName" v-model.trim="ruleForm.activityName" style="width:300px" @input="ruleForm.activityName = ruleForm.activityName.replace(reg, '')" />
      </el-form-item>
      <el-form-item label="活动页标题" prop="viewTitle">
        <el-input v-model="ruleForm.viewTitle" style="width:300px" />
      </el-form-item>
      <el-form-item label="活动充值项" prop="tableData">
        <el-button type="primary" @click="addrecharge">添加活动充值项</el-button>
        <div class="activeybox">
          <el-table
            :data="tableData"
            :row-class-name="tableRowClassName"
            border
            style="width: 100%"
          >
            <el-table-column
              prop="date"
              label="充值类型"
              width="180"
              align="center"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.rechargeType == 0">普通充值</div>
                <div v-if="scope.row.rechargeType == 1">VIP会员</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="充值金额"
              width="180"
              align="center"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.rechargeType == 0">{{ scope.row.price }}元</div>
                <div v-if="scope.row.rechargeType == 1">{{ scope.row.vipxuanzexiang }}元</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="address"
              label="赠送金额"
              align="center"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.rechargeType == 0">{{ scope.row.hongbao }}元</div>
                <div v-if="scope.row.rechargeType == 1">-</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="address"
              label="限购次数"
              align="center"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.xiangouradio === 0">共{{ scope.row.gong }}次</div>
                <div v-if="scope.row.xiangouradio === 1">每天{{ scope.row.mei }}次</div>
                <div v-if="scope.row.gongmeichuan == -1">不限次数</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="address"
              label="操作"
              align="center"
            >
              <!-- slot-scope="scope" -->
              <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="delter(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

      </el-form-item>
      <el-form-item label="期限选择">
        <el-select v-model="time_type" placeholder="请选择">
          <el-option
            v-for="item in timeoptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="time_type === 2" label="固定天数" prop="appoint_day">
        <el-input v-model="ruleForm.appoint_day" style="width:300px" placeholder="请输入固定天数" type="number" :onkeyup="ruleForm.appoint_day = ruleForm.appoint_day.replace(/[^A-z0-9]/, '')" />
      </el-form-item>
      <el-form-item v-if="time_type === 1" label="活动起止时间" prop="timearr">
        <el-date-picker
          v-model="ruleForm.timearr"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width:410px"
          :picker-options="pickerOptions"
          :clearable="false"
          @change="datavalue"
        />
      </el-form-item>
      <el-form-item label="活动倒计时">
        <el-radio-group v-model="ruleForm.hideCountDown">
          <el-radio :label="0">显示</el-radio>
          <el-radio :label="1">隐藏</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="目标用户">
        <el-radio-group v-model="ruleForm.userGroup">
          <el-radio :label="0">所有用户</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item>
        <el-button style="margin-top:10px" type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="添加活动充值项"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <wddialog ref="addpalrview" @callback="callback" />
    </el-dialog>
  </div>
</template>

<script>
import { readingservice } from '@/api/sourceMaterial.js'
import wddialog from './wddialog.vue'
export default {
  components: {
    wddialog
  },
  props: {
    platformid: {
      type: Number,
      default: null
    }
  },
  data() {
    var checkAge = (rule, value, callback) => {
      console.log(this.ruleForm.timearr[0])
      console.log(this.ruleForm.timearr[1])
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.timearr[0] == this.ruleForm.timearr[1]) {
        callback(new Error('不能选择相同的时间'))
      } else {
        callback()
      }
    }
    var checkAger = (rule, value, callback) => {
      // eslint-disable-next-line eqeqeq
      if (this.tableData.length == 0) {
        callback(new Error('请添加活动充值项'))
      } else {
        callback()
      }
    }
    var checkAgere = (rule, value, callback) => {
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.appoint_day.length > 3) {
        callback(new Error('不能超过3位'))
      } else {
        callback()
      }
    }
    return {
      // eslint-disable-next-line no-misleading-character-class
      reg: /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi,
      ruleForm: {
        activityName: '',
        viewTitle: '',
        rechargearr: [],
        timearr: [],
        hideCountDown: 0,
        userGroup: 0,
        appoint_day: ''
      },
      startTime: '',
      endTime: '',
      dialogVisible: false,
      pickerOptions: { // 禁用当前日期之前的日期
        disabledDate(time) {
          // Date.now()是javascript中的内置函数，它返回自1970年1月1日00:00:00 UTC以来经过的毫秒数。
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      rules: {
        activityName: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        viewTitle: [
          { required: true, message: '请输入活动页标题', trigger: 'blur' }
        ],
        tableData: [
          // { type: 'array', required: true, message: '请添加活动充值项', trigger: 'change' }
          { validator: checkAger, trigger: 'change' }
        ],
        appoint_day: [
          { required: true, message: '请输入固定天数', trigger: 'change' },
          { validator: checkAgere, trigger: 'change' }
        ],
        timearr: [
          { type: 'array', required: true, message: '请选择时间', trigger: 'change' },
          { validator: checkAge, trigger: 'change' }
        ],
        rechargearr: [
          { type: 'array', required: true, message: '请添加活动充值项', trigger: 'change' }
        ]
      },
      tableData: [],
      tableDataquery: [],
      timeoptions: [
        {
          value: 1,
          label: '指定期限'
        }, {
          value: 2,
          label: '固定天数'
        }
      ],
      time_type: 2
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex
    },
    datavalue(val) {
      console.log('val', val)
      this.startTime = val[0]
      this.endTime = val[1]
    },
    addrecharge() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.addpalrview.send(this.platformid)
      })
    },
    callback(val) {
      console.log('val', val)
      this.dialogVisible = false
      this.tableData.push(val)
      console.log('this.tableData', this.tableData)
    },
    submitForm(formName) {
      this.tableDataquery = []
      this.tableDataquery = this.tableData.map((item) => {
        if (item.price === '' && item.hongbao === '') {
          return { rechargeType: item.rechargeType, rechargeTimes: item.gongmeichuan, rechargeFrequency: item.xiangouradio, vipConfigId: item.vipConfigId }
        } else {
          return { rechargeType: item.rechargeType, price: Number(item.price), hongbao: Number(item.hongbao), rechargeTimes: item.gongmeichuan, rechargeFrequency: item.xiangouradio }
        }
        //  return { rechargeType: item.rechargeType, price: item.price === '' ? null : item.price, hongbao: item.hongbao === '' ? null : item.hongbao, rechargeTimes: item.gongmeichuan, rechargeFrequency: item.xiangouradio, vipConfigId: item.vipConfigId === null ? null : item.vipConfigId }
      })
      console.log('this.tableDataquery', this.tableDataquery)
      //  ['pop_range' + '[' + this.reding + ']']: this.reding
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const par = {}
          if (this.time_type === 1) {
            par.time_type = this.time_type
            par.start_time = this.startTime
            par.end_time = this.endTime
          } else {
            par.time_type = this.time_type
            par.appoint_day = Number(this.ruleForm.appoint_day)
          }
          readingservice({
            activity_info: {
              activityName: this.ruleForm.activityName,
              // startTime: this.startTime,
              // endTime: this.endTime,
              viewTitle: this.ruleForm.viewTitle,
              userGroup: this.ruleForm.userGroup,
              configs: this.tableDataquery,
              hideCountDown: this.ruleForm.hideCountDown,
              popupConfig: '',
              bottomLinkConfig: '',
              floatWindowConfig: { configs: [], floatWindowUrl: '' },
              bannerUrl: '',
              contentType: 0,
              bannerLocationIds: []
            },
            platform_id: this.platformid,
            activity_type: 1,
            ...par
          }).then((res) => {
            this.$message({
              type: 'success',
              message: '添加成功!'
            })
            this.$emit('close')
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    delter(row) {
      this.tableData.splice(row.index, 1)
      console.log('row', row.index)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.activeybox{
  max-height: 300px;
  overflow: hidden;
  overflow-y: scroll;
  margin-top: 20px;
}
</style>
